/* DON'T EDIT THIS FILE: edit original and run build again */ import { useRealmHandler } from "../../framework/app-state/app-state-context.ts";
import { SupportInfo } from "../../framework/contact-information/support.tsx";
import { matchfinTenant } from "../../framework/tenant-matchfin-code/matchfin-tenant-code.ts";
import { Container } from "react-bootstrap";
import { TenantLogo } from "./logo-tenant.tsx";
// @ts-expect-error this is a string to the path of the image but typescript doesn't know it
import matchfinBackgroundImagePath from "./matchfin_background.jpg";

export const AuthenticationPage = ({
  children,
  right,
  footer,
}: {
  children?: React.ReactNode;
  right?: React.ReactNode;
  footer?: React.ReactNode;
}) => {
  const realm = useRealmHandler().getCode();
  return (
    <div>
      <div
        style={{
          backgroundImage:
            realm === matchfinTenant
              ? "url(" + matchfinBackgroundImagePath + ")"
              : undefined,
        }}
        className={"bg-auth"}
      >
        <div
          style={{
            /* FIXME@UX */ position: "absolute",
            width: "100vw",
            height: "100vh",
          }}
          className="d-flex flex-column"
        >
          <div className="d-flex justify-content-end px-7 pt-6">
            <div className="me-2">{right}</div>
          </div>
          <div className="d-flex justify-content-center pb-3">
            <TenantLogo />
          </div>
          <Container className="flex-grow-1">{children}</Container>
          {footer}
          <SupportInfo callToAction="contactar soporte" />
        </div>
      </div>
    </div>
  );
};
